var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDownSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.9406 17.6233C9.52654 18.1256 10.4781 18.1256 11.064 17.6233L18.564 11.1944C19.15 10.6921 19.15 9.87644 18.564 9.37418C17.9781 8.87192 17.0265 8.87192 16.4406 9.37418L11.5 13.6133V1.28579C11.5 0.574586 10.8297 0 9.99998 0C9.17029 0 8.49998 0.574586 8.49998 1.28579V13.6092L3.55935 9.3782C2.97341 8.87594 2.02185 8.87594 1.43591 9.3782C0.849976 9.88046 0.849976 10.6961 1.43591 11.1984L8.93591 17.6273L8.9406 17.6233Z",
    fill: "#1A2021"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownSolid);
export default __webpack_public_path__ + "static/media/arrow-down-solid.aa8ce1b8342344a79fee18a627e3a34a.svg";
export { ForwardRef as ReactComponent };